<template>
  <div class="export">
    <header class="content-heading">
      <h1 class="txt-header">EXPORT</h1>
    </header>
    <section class="content-main">
      <section class="export-meta">
        <h3 class="txt-button-label">VIDEO LINK</h3>
        <button class="action-button export__download" @click="copyLink">
          <i class="material-icons">file_copy</i>
          Copy Video Link
        </button>
      </section>
      <section class="export-meta">
        <h3 class="txt-button-label _pmb">IFrame Embed Code</h3>
        <div class="videoFormat-select">
          <label>Video format</label>
          <select v-model="videoFormat">
            <option value="16:9">16:9</option>
            <option value="4:3">4:3</option>
            <option value="9:16">9:16</option>
            <option value="3:4">3:4</option>
          </select>
        </div>
        <!--
        <label for="export-meta-url" class="txt-label">HTML url for embed (if empty dynamic url is used)<span class="txt-optional"></span></label>
        <input name="export-meta-url" v-model="url" type="text" placeholder="https://"/>
        -->
        <button class="action-button export__download" @click="copyEmbed">
          <i class="material-icons">file_copy</i>
          Copy Embed Code
        </button>
      </section>
      <section class="export-meta">
        <h3 class="txt-button-label">HTML</h3>
        <a style="display: none" ref="saveAs"></a>
        <button class="action-button export__download" @click="downloadHTML">
          <i class="material-icons">file_download</i>
          Download HTML
        </button>
      </section>
      <section class="export-meta">
        <h3 class="txt-button-label">JSON Data</h3>
        <button class="action-button export__download" @click="downloadJSON">
          <i class="material-icons">file_download</i>
          Download JSON
        </button>
      </section>
      <section class="export-meta">
        <h3 class="txt-button-label">Translations</h3>
        <button class="action-button export__download" @click="downloadTranslation">
          <i class="material-icons">file_download</i>
          Download CSV
        </button>
      </section>
      <section class="export-meta">
        <h3 class="txt-button-label">SCORM</h3>
        <a
          style="text-decoration: none"
          :href="hostname + '/api/video/scormDownload?assetId=' + selectedAsset.id"
          class="export__download"
        >
          <button class="action-button">
            <i class="material-icons">file_download</i>
            Pack Scorm
          </button>
        </a>
      </section>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiBaseUrl } from "../../config";

export default {
  name: "export",
  computed: {
    ...mapGetters(["video", "selectedAsset", "user"])
  },
  data: () => ({
    hostname: apiBaseUrl,
    url: "",
    videoFormat: "16:9"
  }),
  methods: {
    ...mapActions(["notify", "saveAsset"]),
    saveFile: function(data, fileName) {
      var blob = new Blob([data], { type: "text/html" });
      var url = window.URL.createObjectURL(blob);
      this.$refs.saveAs.href = url;
      this.$refs.saveAs.download = fileName;
      this.$refs.saveAs.click();
      window.URL.revokeObjectURL(url);
    },
    packScorm: function(data, fileName) {
      var blob = new Blob([data], { type: "text/html" });
      var url = window.URL.createObjectURL(blob);
      this.$refs.saveAs.href = url;
      this.$refs.saveAs.download = fileName;
      this.$refs.saveAs.click();
      window.URL.revokeObjectURL(url);
    },
    downloadHTML: function() {
      const that = this;
      fetch(
        `${apiBaseUrl}/api/video/download?assetId=${this.selectedAsset.id}`,
        {
          method: "get"
        }
      )
        .then(res => {
          return res.text();
        })
        .then(txt => {
          this.saveFile(
            txt,
            that.selectedAsset.title.replace(/([^a-z0-9]+)/gi, "_") + ".html"
          );
        })
        .catch(e => {
          console.error(e);
        });
    },
    downloadTranslation: function() {
      const that = this;
      fetch(
        `${apiBaseUrl}/api/translate/export?assetId=${this.selectedAsset.id}&token=${this.user.token}&type=csv`,
        {
          method: "get"
        }
      )
        .then(res => {
          return res.text();
        })
        .then(txt => {
          this.saveFile(
            txt,
            that.selectedAsset.title.replace(/([^a-z0-9]+)/gi, "_") + ".csv"
          );
        })
        .catch(e => {
          console.error(e);
        });
    },
    downloadJSON: function() {
      this.saveFile(
        JSON.stringify(this.video),
        this.selectedAsset.title.replace(/([^a-z0-9]+)/gi, "_") + ".json"
      );
    },
    copyLink: function() {
      let baseUrl = apiBaseUrl.replace("http:", "https:");
      const url = `${baseUrl}/api/video?assetId=${this.selectedAsset.id}`;
      this.copyToClipboard(url);

      this.notify({
        title: "Copy video link",
        text: "Video link copied to your clipboard",
        sticky: 2000
      });
    },
    copyEmbed: function() {
      let baseUrl = apiBaseUrl.replace("http:", "https:");
      let embed =
        '<div style="position: relative;padding-bottom: 56.25%;padding-top: 25px;height: 0"><iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" src="' +
        baseUrl +
        "/api/video?assetId=" +
        this.selectedAsset.id +
        '" allowfullscreen webkitallowfullscreen mozAllowFullScreen frameborder="0"></iframe></div>';
      switch (this.videoFormat) {
        case "4:3":
          embed = embed.replace(
            "padding-bottom: 56.25%",
            "padding-bottom: 75%"
          );
          break;
        case "9:16":
          embed = embed.replace(
            "padding-bottom: 56.25%",
            "padding-bottom: 177.77%"
          );
          break;
        case "3:4":
          embed = embed.replace(
            "padding-bottom: 56.25%",
            "padding-bottom: 133.33%"
          );
          break;
      }

      this.copyToClipboard(embed);
      // const embed = '<iframe src="' + baseUrl + '/api/video?assetId=' + this.selectedAsset.id + '" allowfullscreen webkitallowfullscreen mozAllowFullScreen frameborder="0"></iframe>'
      this.notify({
        title: "Copy embed",
        text: "Embed copied to your clipboard",
        sticky: 2000
      });
    },
    copyToClipboard(value) {
      if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        window.clipboardData.setData("Text", value);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = value;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return false;
        } finally {
          document.body.removeChild(textarea);
        }
      }
    }
  }
};
</script>
